import React from 'react';
import Advanced from 'components/Advanced';
import Comments from 'components/Comments';
import type { KeyValueCallback } from 'types/utils.type';
import type { TReservationMode } from '@timeedit/types';
import { TEDrawerSection } from '@timeedit/ui-components';
import Info from './Info';
import { Language } from './Language';
import Properties from './Properties';
import ReservationTemplates from './ReservationTemplates';
import './index.scss';

export interface Props {
  data?: TReservationMode;
  onChange: KeyValueCallback<TReservationMode>;
}

const DrawerContent = (props: Props) => {
  const { data, onChange } = props;
  if (!data) return null;
  return (
    <div className="padding-rule">
      <Info data={data} onChange={onChange} />
      <Properties data={data} onChange={onChange} />
      <ReservationTemplates data={data} onChange={onChange} />
      <TEDrawerSection label="Advanced">
        <Advanced
          options={[]}
          selectedUrl={'reservation-modes'}
          selectedId={data.id}
        />
      </TEDrawerSection>
      <Language
        value={data}
        onChangeValue={(newAltDesignations) =>
          onChange('altDesignations', newAltDesignations)
        }
      />
      <Comments
        value={data.documentation}
        onChange={(val) => onChange('documentation', val)}
      />
    </div>
  );
};

export default DrawerContent;
